<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog append-to-body v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <h3 class="text-center"><i v-if="showForm" class="el-icon-arrow-left back" @click="showForm = false"></i>收货地址</h3>
      <el-row>
        <el-col :span="24" class="tip" v-if="!address">
          添加一个新收货地址
        </el-col>
        <el-col :span="24" v-if="!address && isSingle">
          <el-autocomplete
            style="width:100%;"
            class="inline-input"
            v-model="keyword"
            :fetch-suggestions="querySearch"
            placeholder="搜索填写过的地址"
            :trigger-on-focus="false"
            @select="handleSelect"
          >
          <template slot-scope="{ item }">
            <SingleAddress class="address-info" :address="item"></SingleAddress>
          </template>
          </el-autocomplete>
        </el-col>
        <el-col :span="24" class="tip" v-if="address">
          编辑收货地址
        </el-col>
        <el-col :span="24" v-if="address && isSingle">
          <el-autocomplete
            style="width:100%;"
            class="inline-input"
            v-model="keyword"
            :fetch-suggestions="querySearch"
            placeholder="搜索填写过的地址"
            :trigger-on-focus="false"
            @select="handleSelect"
          >
          <template slot-scope="{ item }">
            <SingleAddress class="address-info" :address="item"></SingleAddress>
          </template>
          </el-autocomplete>
        </el-col>
      </el-row>
      <AddressForm class="dialog-form" :needSave="needSave" :addressInfo="address" :addressSelect="addressSelect" btnType="primary" :support_transport_service="support_transport_service" v-on:success="submit"></AddressForm>
    </el-dialog>
  </div>
</template>

<script>
import AddressForm from './Form'
import AddressList from './AddressList'
import SingleAddress from './SingleAddress'
import api from '../../../services/api.js'
let $ = require('jQuery')

export default {
  name: 'AddAddress',
  props: ['addressId','support_transport_service','address','needSave'],
  components: {
    AddressForm: AddressForm,
    AddressList: AddressList,
    SingleAddress:SingleAddress
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  created () {
    this.isSingle = this.$route.fullPath.indexOf('buyer') > -1;
  },
  data () {
    return {
      dialogFormVisible: false,
      showForm: false,
      isSingle: false,
      keyword: null,
      addressSelect:null,
      addressName: null,
    }
  },
  methods: {
    show () {
      this.dialogFormVisible = true
    },
    async submit (data) {
      if(this.addressName){
        this.$localStorage.set('addressName', this.addressName)
      }
      this.dialogFormVisible = false
      this.showForm = false
      this.$emit('success',data)
    },
    changeAddress (addressInfo) {
      if (!this.addressId) {
        this.taskInfo.address_id = addressInfo.address_id
        this.taskInfo.address_info = addressInfo.address_info
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
      this.dialogFormVisible = false;
      this.$emit('success', addressInfo)
    },
    async querySearch(queryString,cb) {
      let params = {
        keyword: queryString
      }
      let res = await api.serchAddressBySingle(this,params)
      if(res.body.status == 'ok') {
        cb(res.body.result)
      }
    },
    handleSelect (item) {
      console.log(item)
      this.addressSelect = item
      this.addressName = item.buyer_username
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 40px;
  }
  .tip {
    font-size:16px;
    color:rgba(136,136,136,1);
    line-height:24px;
    margin-bottom: 5px;
  }
  .add-tip {
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:24px;
    margin-left: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
  }
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/AddAddressDialog.vue